import { Box, Typography } from '@mui/material'
import { UnitBatch } from '../../api/types'
import { QueueColumn, QueueTable } from '../../components/QueueTable'
import { StatusChip } from '../../components/StatusChip'
import { formatCzk, formatDate, formatDateTime, formatUnits } from './format'

interface BatchHistoryCardProps {
  /** Klíč fondu — remount QueueTable při přepnutí (drží řazení/hledání). */
  fundKey: string
  batches: UnitBatch[]
  onRowClick: (batch: UnitBatch) => void
}

/** Historie přepočtů fondu (audit trail). Řádek otevírá detail přepočtu. */
export function BatchHistoryCard({ fundKey, batches, onRowClick }: BatchHistoryCardProps) {
  const columns: QueueColumn<UnitBatch>[] = [
    {
      key: 'assignmentDate',
      label: 'Datum přidělení',
      getSortValue: (b) => b.assignmentDate,
      render: (b) => formatDate(b.assignmentDate),
    },
    {
      key: 'navTotal',
      label: 'NAV',
      align: 'right',
      getSortValue: (b) => b.navTotal,
      render: (b) => formatCzk(b.navTotal),
    },
    {
      key: 'unitPrice',
      label: 'Cena',
      align: 'right',
      getSortValue: (b) => b.unitPrice,
      render: (b) => formatUnits(b.unitPrice),
    },
    {
      key: 'units',
      label: 'Jednotky (před → po)',
      align: 'right',
      render: (b) => (
        <Typography variant="body2">
          {formatUnits(b.totalUnitsBefore)} → {formatUnits(b.totalUnitsAfter)}
        </Typography>
      ),
    },
    {
      key: 'participants',
      label: 'Účastníků',
      align: 'right',
      getSortValue: (b) => b.participants.length,
      render: (b) => b.participants.length,
    },
    {
      key: 'status',
      label: 'Stav',
      render: (b) => <StatusChip status={b.status} />,
    },
    {
      // sort dle createdAt (klíč sloupce = defaultSortKey historie)
      key: 'createdAt',
      label: 'Vytvořil',
      getSortValue: (b) => b.createdAt,
      render: (b) => (
        <Box>
          <Typography variant="body2">{b.createdBy}</Typography>
          <Typography variant="caption" color="text.secondary" component="div">
            {formatDateTime(b.createdAt)}
          </Typography>
        </Box>
      ),
    },
  ]

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
        Historie přepočtů (audit trail)
      </Typography>
      <QueueTable
        key={fundKey}
        columns={columns}
        rows={batches}
        getRowKey={(b) => b.id}
        defaultSortKey="createdAt"
        defaultSortDir="desc"
        emptyText="Žádné přepočty"
        onRowClick={onRowClick}
      />
    </Box>
  )
}
